/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { CampaignTemplate } from 'cio/services/campaign-templates';

interface Args {
  templates: CampaignTemplate[];
  onSelectTemplate: (campaign: CampaignTemplate) => void;
}

export default class TemplatePickerComponent extends Component<Args> {
  @action
  handleSelectTemplate(template: CampaignTemplate) {
    this.args.onSelectTemplate(template);
  }
}
